module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.$route.name != 'Index'),
      expression: "this.$route.name != 'Index'"
    }],
    staticClass: "footer-wrap"
  }, [_c('div', {
    staticClass: "footer-cont clear"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: " fl clear"
  }, [_c('li', {
    staticClass: "fl"
  }, [_c('Tooltip', {
    staticClass: "contact-us",
    attrs: {
      "placement": "top"
    }
  }, [_c('Button', {
    staticClass: "tips",
    on: {
      "mouseenter": function($event) {
        return _vm.enter()
      },
      "mouseleave": function($event) {
        return _vm.leave()
      }
    }
  }, [_vm._v("更多\n\t\t\t        \t"), (_vm.status) ? _c('i', {
    staticClass: "iconfont more-btn"
  }, [_vm._v("")]) : _c('i', {
    staticClass: "iconfont more-btn"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "more-list"
  }, _vm._l((_vm.tipsArr), function(item) {
    return _c('li', [_c('i', {
      staticClass: "iconfont",
      class: {
        'special': item.name == '关于我们'
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.baceUrl + item.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line fl"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "line fl"
  }), _vm._v(" "), _c('li', {
    staticClass: "fl"
  }, [_c('Tooltip', {
    staticClass: "contact-us",
    attrs: {
      "placement": "top"
    }
  }, [_c('Button', {
    staticClass: "tips"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', {
    staticClass: "phone-icon"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('p', {
    staticClass: "tel"
  }, [_vm._v("15652730502")]), _vm._v(" "), _c('p', {
    staticClass: "work-time"
  }, [_vm._v("工作日：10:00-19:00")]), _vm._v(" "), _c('p', {
    staticClass: "kefu"
  }, [_c('span', [_vm._v("客服电话")])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line fl"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "fr weichat"
  }, [_c('Tooltip', {
    staticClass: "contact-us",
    attrs: {
      "placement": "top"
    }
  }, [_c('Button', {
    staticClass: "tips"
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/erweima.png"),
      "alt": ""
    }
  })])])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-logo fl"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/logo-bottom.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "fl"
  }, [_c('a', {
    attrs: {
      "href": "http://breadoffer.com/aboutus/qa.html",
      "target": "_blank"
    }
  }, [_vm._v("常见问题")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "fl weibo"
  }, [_c('a', {
    attrs: {
      "href": "http://www.weibo.com/breadoffer?refer_flag=1005055013_",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont"
  }, [_vm._v("")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46eed7f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 208
// module chunks = 19